// flowgenIgnore
export { createDuck } from './createDuck';
export * from './types';



// WEBPACK FOOTER //
// ../react-lib/src/lib/redux-duck/index.ts